import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

// TODO: add error reporting service,
// sending with it the error, action and state
const errorHandlingMiddleware = ({ dispatch, getState }) => next => action => {
    return Promise.resolve(next(action))
        .catch(err => {
            // this short circuit is here to avoid displaying a
            //  barrage of error messages on session expiration
            //   ideally http request errors will be handled as
            //    close to the call as possible
            if (err instanceof XMLHttpRequest) {
                return;
            }
            /* eslint-disable no-console */
            console.error(err);
            /* eslint-enable no-console */
            let type = 'error', message = 'Sorry there is an error with the application';
            let action = addApplicationMessage(type, message);
            dispatch(action);
        });
};

export default errorHandlingMiddleware;
